import { React, useEffect } from 'react';
import '../../stylesheets/CodeSS.css';
import Prism from 'prismjs'
import "../../stylesheets/prism.css"
import copy from '../../images/icons/copy.svg'

function Code({ text, language }) {
  useEffect(()=>{
    Prism.highlightAll();
  })

  //if no code provided, dont render anything
  if(text===undefined){
    return(<div style={{display:"none"}}></div>);
  }
  let indent = false;

  async function getText(e) {
    // console.log(e.target);
    //going out to THIS code copy parent and selecting list items
    let copyString = '';

    //getting the code lines
    let ol = e.target.parentElement.parentElement.children[1].children;
    
    //looping through lines and accessing text
    for(let i = 0; i < ol.length; i++){
      copyString = copyString + "\n" + ol[i].children[1].innerText;
    }

    //add copyString to users clipboard
    navigator.clipboard.writeText(copyString);

    //create popup and fade then remove to say copied!
    let cMessage = document.createElement('span');
    cMessage.innerText = 'copied!';
    cMessage.className = 'msg_copy';
    cMessage.style.left = (e.clientX+20) + 'px'
    cMessage.style.top = (e.clientY-8) + 'px'
    e.target.parentElement.appendChild(cMessage);
    setTimeout(()=>{
      cMessage.style.opacity = '0';
      setTimeout(()=>{
        cMessage.remove();
      },500)
    },100)

  }

  // will be split by new lines
  let lines = text.split('\n');
  return (
    <div className='code_container'>
      <button id='copy' onClick={getText}><img src={copy} alt='copy'></img></button>
      <ol className='code_block'>
        {lines.map((line, index) => {
          if (index > 0 && index < lines.length - 1) {
            if (lines[index - 1].includes('{')) {
              indent = true;
            }
            if ((lines[index].includes('}')) && !(lines[index].includes('{'))) {
              //not indent the next line
              indent = false;
            }
            if (indent) {
              //add indent
              indent = true;
              return (<li key={index} className='line'><span className='line_no'>{index + 1}</span>&emsp;&emsp;<pre><code className={`language-${language}`}>{line}</code></pre></li>)
            } else {
              indent = false;
            }
          }
          return (
            <li key={index} className='line'><span className='line_no'>{index + 1}</span><pre><code className={`language-${language}`}>{line}</code></pre></li>
          )
        })}
      </ol>

    </div>
  )
}

export default Code